// extracted by mini-css-extract-plugin
export var standaloneTable = "_jc-0";
export var standaloneTableWithBodyFill = "_jc-1";
export var withExtraHeader = "_jc-2";